import React from 'react'
import "../styles/intro.css";
import logo from'../assets/iqclear.png'
import q from'../assets/q.png'
import k from'../assets/k.png'
import i from'../assets/i.png'
import Grid from "@material-ui/core/Grid";

function Intro() {
    return (
        <Grid container  spacing={2} >

        <Grid item sm={12} xs={12} style={{ 
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
            }}>
        <div className="circles zoomIn" style={{position: "relative"}}>
           
        </div>
        <img className="slideInDown" style={{position: "absolute", top: 300}}  src={logo} alt=""/>
        <img className="slideInRight" style={{position: "absolute", top: 300}}  src={q} alt=""/>
        <img className="slideInUp" style={{position: "absolute", top: 300}}  src={k} alt=""/>
        <img  style={{position: "absolute", top: 300}}  src={i} alt=""/>
        </Grid>
        </Grid>
    )
}

export default Intro
